import { useForm } from "react-hook-form";
import DepartmentRequestModel from "../../../models/company/department/request/DepartmentRequestModel";
import { OBJECT_NAME_RULE, OBJECT_DESCRIPTION_RULE } from "../../../utils/validation-utils";
import toasterUtils from "../../../utils/toaster-utils";
import { Button, FormControl, TextField } from "@mui/material";

interface DepartmentProps {
    objDepartment: DepartmentRequestModel;
    actionType: string;
    onCloseDepartment: () => void;
    onDepartmentSave: (objDepartment: DepartmentRequestModel) => void;
}

const DepartmentCreateComponent = (props: DepartmentProps) => {
    const {
        register,
        setValue,
        getValues,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<DepartmentRequestModel>({
        mode: "onChange",
        defaultValues: props.objDepartment
    });

    const onSubmit = (formData: DepartmentRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        props.onDepartmentSave(formData);
    }

    return (
        <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.departmentName}>
                        <TextField label="Department Name" size="small" {...register("departmentName", OBJECT_NAME_RULE)} error={!!errors.departmentName}
                            helperText={errors.departmentName?.message} autoComplete="off" required />
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.description}>
                        <TextField label="Description" multiline rows={3} size="small"
                            {...register("description", OBJECT_DESCRIPTION_RULE)} error={!!errors.description} helperText={errors.description?.message} autoComplete="off" />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 text-end m-t-sm">
                    <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                        Save
                    </Button>
                    <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseDepartment}>
                        Close
                    </Button>
                </div>
            </div>
        </form>
    );
};
export default DepartmentCreateComponent;